import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TourConfig, TourService, Tour } from 'map-wald-leaflet';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  tours: TourConfig[];
  @Output() tourStarted = new EventEmitter<Tour>();

  constructor(tourService:TourService) {
    tourService.tours$.subscribe(tours=>{
      this.tours = tours;
    });
  }

  ngOnInit(): void {
  }

  _tourStarted(tour:Tour):void {
    this.tourStarted.emit(tour);
  }
}
